import React, { Suspense } from 'react'
import { Spin } from 'antd'
import { Switch, Route, useRouteMatch } from 'react-router-dom'
import CarOwnersGrid from '../../container/car_owners/grid'

const CarOwnerRoutes = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Suspense
        fallback={
          <div className='spin'>
            <Spin />
          </div>
        }
      >
        <Route exact path={path} component={CarOwnersGrid} />
      </Suspense>
    </Switch>
  )
}

export default CarOwnerRoutes
